module.exports = __webpack_public_path__ + "static/20-14-7695cd966f21931590ad467a9f6689e3.jpg";